const SondageIntegrated = ({language , token}) => {
    const newSondageIframe = "https:" +
    window.process.env.URL_Stats
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_sondage_display"
        src={newSondageIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default SondageIntegrated